const redirectMenuTypes = [
  {
    label: 'Aba',
    value: 'aba',
  },
  {
    label: 'Card',
    value: 'card',
  },
  {
    label: 'Tabs',
    value: 'tabs',
  },
];

export default redirectMenuTypes;
